import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "@/redux/hooks";
import { useRegistrarOrigemMutation } from "@/services/auth.service";
import {
  capturarOrigemDaUrl,
  marcarOrigemReportada,
  origemPendenteParaUsuario,
} from "@/lib/origem-aquisicao";

/**
 * Guarda utm_* da URL e, quando houver usuário logado, envia a origem uma vez por conta
 * (o backend decide se a conta é nova e grava `OrigemCadastro`).
 */
export function useOrigemAquisicaoSync() {
  const location = useLocation();
  const userId = useAppSelector((state) => state.authReducer?.id) || null;
  const [registrarOrigem] = useRegistrarOrigemMutation();
  const enviandoRef = useRef<string | null>(null);

  useEffect(() => {
    capturarOrigemDaUrl(location.search, location.pathname);
  }, [location.search, location.pathname]);

  useEffect(() => {
    const origem = origemPendenteParaUsuario(userId);
    if (!userId || !origem || enviandoRef.current === userId) return;
    enviandoRef.current = userId;

    registrarOrigem({
      utm_source: origem.utm_source,
      utm_medium: origem.utm_medium,
      utm_campaign: origem.utm_campaign,
      grupoId: origem.grupoId,
      primeiroToqueEm: origem.primeiroToqueEm,
      canal: "web",
    })
      .unwrap()
      .then(() => marcarOrigemReportada(userId))
      .catch(() => {
        enviandoRef.current = null;
      });
  }, [userId, location.pathname, registrarOrigem]);
}
